
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class FuelPriceService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	) {
		this.url = urlService.getURL('FuelPrice');
	}

	loadAll(): Observable<TooBig4Car.Logic.FuelPrice[]> {
		return this.myBaseService.loadAll(this.url);
	}
	save(tempItem: TooBig4Car.Logic.FuelPrice): Observable<TooBig4Car.Logic.FuelPrice> {
		return this.myBaseService.save(tempItem, this.url);
	}
	deleteItem(id: System.Guid): Observable<boolean> {
		return this.myBaseService.deleteItem(id, this.url);
	}
	getEdit(id: System.Guid): Observable<TooBig4Car.Logic.FuelPrice> {
		return this.myBaseService.getEdit(id, this.url);
	}
	get(id: System.Guid): Observable<TooBig4Car.Logic.FuelPrice> {
		return this.myBaseService.get(id, this.url);
	}
	getBulkData(custID: System.Guid): Observable<TooBig4Car.Logic.FuelPriceDataVM> {
		return this.myBaseService.get(custID, this.url + '/Data');
	}
	saveBulkData(custID: System.Guid, tempItem: TooBig4Car.Logic.FuelSurchargeSettingsVM): Observable<any> {
		return this.myBaseService.post(tempItem, this.url + '/Data/' + (custID ?? this.myBaseService.configData.DefaultEmptyGuid), true);
	}
}			
